import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  Button,
  IconButton
} from '@mui/material';
import axios from 'axios';
import { Skeleton } from "@mui/material";
import { useTheme, useMediaQuery, TableContainer } from '@mui/material';
import UserDetailsDialog from '../../../components/UserDetailsDialog';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FreezUserDialog from '../../../components/FreezeUserDialog';
import CircularProgress from '@mui/material/CircularProgress';
import uiColors from '../../../Styles/uiColors';




const AllUsers = () => {
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [openFreezDialog, setOpenFreezDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [freezUserId, setFreezUserId] = useState(null);
  const [unfreezLoadingId, setUnfreezLoadingId] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();



  const DEFAULT_API = process.env.REACT_APP_API_URL || "";


  const fetchAllUsers = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${DEFAULT_API}/api/users/all`);
      setUsers(res.data);
    } catch (err) {
      console.error('Error fetching users:', err);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchAllUsers();
  }, []);

  const unfreezUser = async (id) => {
    try {
      setUnfreezLoadingId(id);

      await axios.put(`${DEFAULT_API}/api/users/unfreez/${id}`);
      await fetchAllUsers();

    } catch (err) {
      console.error("Unfreeze error:", err);
    } finally {
      setUnfreezLoadingId(null);
    }
  };


  const handleViewUser = (user) => {
    setSelectedUser(user);
    setOpenDialog(true);
  };

  const handleFreezUser = (user) => {
    setFreezUserId(user._id);
    setOpenFreezDialog(true);

  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedUser(null);
  };



  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Box p={3}>
      <Box sx={{
        mb: 3,
        borderRadius: 3,
        display: 'flex',
        alignItems: 'center',
        gap: 2
      }}>

        <IconButton onClick={() => navigate(-1)}>
          <ArrowBackIcon sx={{ color: uiColors.text.primary }} />
        </IconButton>
        <Typography variant={isMobile ? 'h6' : 'h5'} sx={{ color: "white" }}>
          All Users
        </Typography>
      </Box>


      <TableContainer sx={{ maxWidth: '100%', overflowX: 'auto', bgcolor: uiColors.card, borderRadius: 1 }}>
        <Table size={isMobile ? 'small' : 'medium'}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ color: uiColors.text.primary }}>Name</TableCell>
              <TableCell sx={{ color: uiColors.text.primary }}>Email</TableCell>
              <TableCell sx={{ color: uiColors.text.primary }}>Role</TableCell>
              <TableCell sx={{ color: uiColors.text.primary }}>Status</TableCell>
              <TableCell sx={{ color: uiColors.text.primary }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading
              ? Array.from({ length: rowsPerPage }).map((_, index) => (
                <TableRow key={index}>
                  <TableCell><Skeleton width="80%" sx={{
                    bgcolor: uiColors.skeleton.baseColor,
                    "&::after": { bgcolor: uiColors.skeleton.highlightColor }
                  }} /></TableCell>
                  <TableCell><Skeleton width="90%" sx={{
                    bgcolor: uiColors.skeleton.baseColor,
                    "&::after": { bgcolor: uiColors.skeleton.highlightColor }
                  }} /></TableCell>
                  <TableCell><Skeleton width="60%" sx={{
                    bgcolor: uiColors.skeleton.baseColor,
                    "&::after": { bgcolor: uiColors.skeleton.highlightColor }
                  }} /></TableCell>
                  <TableCell><Skeleton width="50%" sx={{
                    bgcolor: uiColors.skeleton.baseColor,
                    "&::after": { bgcolor: uiColors.skeleton.highlightColor }
                  }} /></TableCell>
                  <TableCell>
                    <Box display="flex" gap={1}>
                      <Skeleton variant="rounded" width={60} height={30} sx={{
                        bgcolor: uiColors.skeleton.baseColor,
                        "&::after": { bgcolor: uiColors.skeleton.highlightColor }
                      }} />
                      <Skeleton variant="rounded" width={80} height={30} sx={{
                        bgcolor: uiColors.skeleton.baseColor,
                        "&::after": { bgcolor: uiColors.skeleton.highlightColor }
                      }} />
                    </Box>
                  </TableCell>
                </TableRow>
              ))
              : users
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((user, index) => (
                  <TableRow key={index}>
                    <TableCell sx={{ color: uiColors.text.primary }}>{user.fullName}</TableCell>
                    <TableCell sx={{ color: uiColors.text.primary }}>{user.email}</TableCell>
                    <TableCell sx={{ color: uiColors.text.primary }}>{user.role}</TableCell>
                    <TableCell sx={{ color: uiColors.text.primary }}>{user.status}</TableCell>
                    <TableCell sx={{ color: uiColors.text.primary }}>
                      <Box display="flex" gap={1}>
                        <Button
                          size="small"
                          sx={{
                            minWidth: isMobile ? 50 : 80, color: "white",
                            background: uiColors.gradient,
                            "&:hover": {
                              background: uiColors.gradientHover,
                              transform: "translateY(-2px)",
                              boxShadow: "0 6px 20px rgba(17,203,226,0.4)"
                            }
                          }}

                          onClick={() => handleViewUser(user)}
                        >
                          VIEW
                        </Button>

                        <Button
                          size="small"
                          sx={{
                            minWidth: isMobile ? 60 : 80, color: "white",
                            background: uiColors.gradient,
                            "&:hover": {
                              background: uiColors.gradientHover,
                              transform: "translateY(-2px)",
                              boxShadow: "0 6px 20px rgba(17,203,226,0.4)"
                            }
                          }}
                          onClick={() =>
                            user.status === "freezed" ? unfreezUser(user._id) : handleFreezUser(user)
                          }
                        >
                          {unfreezLoadingId === user._id ? (
                            <CircularProgress size={18}  />
                          ) : (
                            user.status === "freezed" ? "UNFREEZE" : "FREEZE"
                          )}
                        </Button>

                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
          </TableBody>

        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        count={users.length}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        sx={{
          color: "white",
          "& .MuiTablePagination-actions .MuiIconButton-root": {
            color: "white"  
          },
          "& .MuiSelect-select, & .MuiInputBase-root, & .MuiTablePagination-displayedRows": {
            color: "white" 
          },
          "& .MuiTablePagination-selectIcon": {
            color: "white"  
          }
        }}
      />

      <UserDetailsDialog
        open={openDialog}
        onClose={handleCloseDialog}
        user={selectedUser}
      />

      <FreezUserDialog
        open={openFreezDialog}
        handleClose={() => setOpenFreezDialog(false)}
        userId={freezUserId}
        handleFreez={() => {
          fetchAllUsers();
        }}
      />

    </Box>
  );
};

export default AllUsers;